import { http, HttpResponse } from 'msw'

import { allProducts } from '@/mocks/data/catalogue/products'

import { isNumeric } from '@/utils/app/number'
import { searchParametersProductApi } from '@/utils/catalogue/products'
import { api } from '@/utils/constants'

import { ProductsRequest } from '@/types/catalogue/product'

export const getAllProducts = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.LIST}`,
    ({ request }) => {
        const url = new URL(request.url)

        const limitQuery = url.searchParams.get('limit')
        const offsetQuery = url.searchParams.get('offset')

        const managerQuery = url.searchParams.get(
            searchParametersProductApi.MANAGERS,
        )

        const nameQuery = url.searchParams.get(searchParametersProductApi.NAME)

        let productsFiltered = allProducts

        // Manager filter
        if (managerQuery) {
            productsFiltered = allProducts.filter(
                (product) => product.client.id.toString() === managerQuery,
            )
        }

        // Name filter
        if (nameQuery) {
            productsFiltered = allProducts.filter((product) =>
                product.name.toLowerCase().includes(nameQuery.toLowerCase()),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray = Math.min(productsFiltered.length, offset + limit)
        const results = productsFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < productsFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<ProductsRequest>({
            next,
            results,
        })
    },
)
